import { IntegrationBar } from "@/components/integrationBar";
import { IntegrationsNav } from "@/components/integrations-nav";
import { platformsQueryOpts } from "@/hooks/platform";
import { getOrgIdWithFallback } from "@/lib/utils";
import { useAuth } from "@/providers/auth";
import { useOrg } from "@/providers/organization";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$org/integrations")({
  component: RouteComponent,
  loader: ({ context }) => {
    const { getToken, setToken } = context.auth;
    const orgId = getOrgIdWithFallback(context.org.orgId);

    context.queryClient.ensureQueryData(
      platformsQueryOpts({
        setToken,
        token: getToken() as string,
        orgId: orgId,
      }),
    );
  },
});

function RouteComponent() {
  const { getToken, setToken } = useAuth();
  const { orgId } = useOrg();
  const resolvedOrgId = getOrgIdWithFallback(orgId);
  const { data: accounts, isLoading } = useQuery(
    platformsQueryOpts({
      setToken,
      token: getToken() as string,
      orgId: resolvedOrgId,
    }),
  );

  return (
    <div>
      <IntegrationBar accounts={accounts ?? []} isLoading={isLoading} />
      <IntegrationsNav />
      <Outlet />
    </div>
  );
}
